module.exports = __webpack_public_path__ + "img/697.bc21057c.png";